const Background = (props) => {
  return (
    <div
      style={{
        background: props.background || "linear-gradient(to bottom right ,#eaf7f8 , #91d6e3 )",
        width: "100vw",
        height: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* <div id="stars" />
      <div id="stars2" />
      <div id="stars3" /> */}
      {props.children}
    </div>
  );
};
export default Background;
